import React from 'react';
import sprintf from 'sprintf';
import SMAppHelper from './SMAppHelper';
import moment from 'moment';
import SMConst from 'lib/SMConst';
import SMPlanHelper from './SMPlanHelper';
import urlPaser from 'url';
import SMRailsBridge from 'lib/SMRailsBridge.js.erb';

class SMFormatHelper {

  static ownerName(owner){
    if (owner.is_corp) {
      return owner.corp_name;
    }
    return owner.name;
  }

  static userNameWithReservation(reservation){
    if (SMAppHelper.userIsCorp(reservation)) {
        return reservation.user.name + "(" + reservation.user.corp_name + ")";
    }
    return reservation.user.name;
  }

  static spaceName(space){
    return space.name || sprintf(I18n.t("dashboard.label_000131"), space.id);
  }

  static spaceNameWithType(space){
    return sprintf("%s(%s)", this.spaceName(space), space.space_type_text);
  }

  static roomName(room){
    if (!room.name) {
      return room.space.name;
    }
    return room.name;
  }

  static roomNameWithSpace(room){
    return sprintf("%s(%s)", this.roomName(room), this.spaceName(room.space));
  }

  static capacity(room){
    if (room.capacity) return sprintf("〜%s人", room.capacity);
    return sprintf("-");
  }

  static area(room){
    if (room.area) return sprintf("%s㎡", room.area);
    return sprintf("-");
  }

  static imageURLWithOptions(url, options) {
  }

  static imageURLWithTransform(url, transform={}) {
    const urlObject = urlPaser.parse(url);
    let queries = {};
    if (urlObject.search) {
      const searches = urlObject.search.split('&');
      searches.forEach((search, index)=>{
        const [key, value] = search.split('=');
        queries[key.replace('?', '')] = value;
      });
    }

    if (transform.crop === 'pad') queries['da'] = 'l';
    else if (transform.crop === 'fill') queries['da'] = 's';

    queries['ds'] = 's';
    if (transform.quality) queries['q'] = transform.quality;
    if (transform.fetch_format) queries['of'] = transform.fetch_format;
    if (transform.width) {
      queries['dw'] = transform.width;
      queries['cw'] = transform.canvasWidth || transform.width;
    }
    if (transform.height) {
      queries['dh'] = transform.height;
      queries['ch'] = transform.canvasHeight || transform.height;
    }
    queries['cc'] = transform.background ? transform.background.replace(/#/g, '') : '9c9c9c';

    let newSearches = [];
    for (const key in queries) {
      newSearches.push(`${key}=${queries[key]}`);
    }

    urlObject.search = newSearches.join('&');
    return urlPaser.format(urlObject);
  }

  static spaceImageURL(space, options={}){
    if (space.cover_photo) {
      return this.imageURLWithTransform(space.cover_photo, options);
    }
    return "";
  }

  static roomImageURL(room, options={}){
    if (room.thumbnails && room.thumbnails.length > 0) {
      return this.imageURLWithTransform(room.thumbnails[0].image, options);
    }
    return "";
  }

  static favoriteListImageURL(favoriteList, options={}){
    if (favoriteList.thumbnail) {
      return this.imageURLWithTransform(favoriteList.thumbnail, options);
    } else {
      return "";
    }
  }

  static nl2br(text){
    return text.replace(/\r?\n/g, '<br />');
  }

  static messageContent(message){
    if (message.content) {
      let content = message.content.replace(/\r?\n/g, '<br />');
      if (message.alert_type == SMConst.AlertType.NgWord) {
        content += '<span class="dashboard-message-baloon__info">' + message.alert_text + '</span> ';
      }
      return content;
    }
    return "";
  }

  static description(content){
    if (content) {
      return content.replace(/\r?\n/g, '<br />');
    }
    return "-";
  }

  static messageName(message, reservation){
    let name;
    if (message.from_type == 'AdminUser') {
      name = I18n.t("dashboard.label_000001");
    }
    else if (message.from_type == 'Owner') {
      name = SMFormatHelper.ownerName(reservation.owner);
    } else {
      name = SMFormatHelper.userNameWithReservation(reservation);
    }
    return name;
  }

  static reservationOptionQuantity(option){
    if (!option.number) {
        return "";
    } else {
        let unit = "";
        let number = "";
        let amount = option.price_text;

        if (option.countable) {
            number = "x" + option.number;
        }
        if (option.session_price_unit && option.session_price_unit != "") {
            unit = option.session_price_unit;
        }
        if (unit != "") {
          unit = sprintf("/%s", unit);
        }
        return sprintf("%s%s %s", amount, unit, number);
    }
  }

  static relativeTime(datetime){
    const m = moment(datetime, 'YYYY-MM-DD HH:mm Z', 'ja');
    return m.fromNow();
  }

  static date(datetime, format, locale){
    const m = moment(datetime, format, "ja");
    return m.fromNow();
  }

  static statusText(reservation){
    // マニュアル
    // if (SMReservationHelper.isOwnerDirect(reservation.mediator)) {
    //   return I18n.t("dashboard.label_000154");
    // }
    switch (reservation.method) {
      case SMConst.ReservationMethod.Reservation:
        return reservation.status_text;
      case SMConst.ReservationMethod.Inquiry:
        return I18n.t("dashboard.label_000153");
      case SMConst.ReservationMethod.Concierge:
        if(reservation.concierge && reservation.concierge.via == SMConst.ConciergeVia.Concierge) {
          return I18n.t("dashboard.label_000800");
        } else {
          return I18n.t("dashboard.label_000153");
        }

      default:
    }
    return "";
  }

  static statusClassName(reservation){

    // マニュアル
    // if (SMReservationHelper.isOwnerDirect(reservation.mediator)) {
    //   return "is-approval";
    // }
    // お問い合わせ
    if (reservation.method == SMConst.ReservationMethod.Inquiry) {
      return "is-reserve";
    }

    switch (reservation.status) {
      case SMConst.ReservationStatus.Sent:
      case SMConst.ReservationStatus.EntrustedOwner:
      case SMConst.ReservationStatus.Requested:
        return "is-reserve";
      case SMConst.ReservationStatus.Confirmed:
        return "is-approval";
      case SMConst.ReservationStatus.CancelSent:
      case SMConst.ReservationStatus.Cancelled:
      case SMConst.ReservationStatus.OwnerCancelled:
      case SMConst.ReservationStatus.SystemCancelled:
      case SMConst.ReservationStatus.Rejected:
        return "is-cancel";
        // c = "is-unavailable";
        // break;
      case SMConst.ReservationStatus.Paid:
      case SMConst.ReservationStatus.Paying:
      case SMConst.ReservationStatus.Ended:
      case SMConst.ReservationStatus.Postpay:
        return "is-approval";
      case SMConst.ReservationStatus.Refunded:
      case SMConst.ReservationStatus.Onsite:
      case SMConst.ReservationStatus.Invoice:
        return "is-done";
      case SMConst.ReservationStatus.Expired:
        return "is-done is-past";
      default:
    }
    return "";
  }

  static errorText(resource, field, errors){
    let errorText = '';
    if (errors) {
      for (let i=0; i < errors.length; i++) {
        if (errors[i].resource == resource && errors[i].field == field) {
          errorText += errors[i].message;
        }
      }
    }
    return errorText;
  }

  static duration(duration){
    const d = parseInt(duration);
    const day = 1440;
    const hour = 60;
    if (d >= day) {
      return sprintf(I18n.t("dashboard.label_000114"), d / day );
    } else if (d >= hour) {
      return sprintf(I18n.t("dashboard.label_000113"), d / hour );
    }
    return "";
  }

  static price(price){
    if (price == null || price == '') {
      return null;
    } else {
      const num = parseInt(price);
      if (isFinite(num) && num == price) {
        return num;
      } else {
        return price;
      }
    }
  }

  static getUrlArgString (queries){
    let params = [];
    for(let k in queries) {
      let v = queries[k];
      if (k == 'keyword' || k == 'location') {
         v = encodeURI(v);
      }
      params.push(k + "=" + v);
    }
    return params.length > 0 ? "?" + params.join("&") : "";
  }

  static unavailabilityText(unavailability, style){
    var displayStartWeekDays = '',
        hours,
        endedAt = new Date(unavailability.ended_at),
        startWeekDays = unavailability.start_weekday.split(','),
        startDay = '',
        endDay = '';

    if (unavailability.frequency == SMConst.Frequency.Weekly) {
      if (startWeekDays != '' && startWeekDays.length < 7) {
        for (var j=0; j < startWeekDays.length; j++) {
          if (displayStartWeekDays.length > 0) {
            displayStartWeekDays += '・';
          }
          displayStartWeekDays += I18n.t('date.abbr_day_names')[parseInt(startWeekDays[j])];
        }
      }
      if (unavailability.is_holiday) {
        displayStartWeekDays += '祝日';
      }
    } else if (unavailability.frequency == SMConst.Frequency.Daily) {
      displayStartWeekDays += '毎日';
    }

    if (unavailability.is_all_day) {
      hours = '終日';
      endDay = new Date(unavailability.ended_on);
      if (style == 'list') {
        startDay = I18n.l('date.ymd', unavailability.started_on);
        endDay = I18n.l('date.ymd', endDay);
      } else {
        startDay = I18n.l('date.ym_slash', unavailability.started_on);
        endDay = I18n.l('date.ym_slash', endDay);
      }
    } else {
      const startHour = new Date(unavailability.started_at).getHours();
      const endHour = new Date(unavailability.ended_at).getHours();
      endDay = new Date(unavailability.ended_at);
      if (endDay.getHours() === 0) endDay.setDate(endDay.getDate() - 1);
      if (style == 'list') {
        startDay = I18n.l('date.ymd', unavailability.started_at);
        endDay = I18n.l('date.ymd', endDay);
      } else {
        startDay = I18n.l('date.ym_slash', unavailability.started_at);
        endDay = I18n.l('date.ym_slash', endDay);
      }
    }

    if (unavailability.is_all_day) {
      hours = '終日';
    } else {
      var startHour = new Date(unavailability.started_at).getHours(),
          endHour = new Date(unavailability.ended_at).getHours();
      hours = startHour + ':00 〜 ' + endHour + ':00';
    }

    if (style == 'list') {
      return startDay+' 〜 '+endDay+' / '+displayStartWeekDays+' / '+hours;
    } else if (style == 'calendar') {
      return([
        startDay+' 〜 '+endDay+displayStartWeekDays,
        <span key={0} className="dashboard-calendar__content-value">{hours}</span>
      ]);
    }
  }

  static planName(plan){
    if (plan) {
      let name = SMPlanHelper.isRoom(plan) ? plan.plan_name : plan.name;
      if (!name) name = "基本プラン";
      return name;
    }
  }

  static bankPaymentName(contact){
    const contactName = contact.family_name + contact.given_name;
    if (contact.is_corp) {
      return contact.corp_name;
    } else {
      return contactName;
    }
  }

  static priceUnit(unit_text, hasSuffix){
    const splitter = unit_text ? "/" : "";
    const suffix = splitter && hasSuffix ? "〜" : "";
    return splitter + unit_text + suffix;
  }

  static separateAmount(rawAmount){
    const amount = Number(rawAmount);
    return amount.toLocaleString();
  }

  static searchRangeDateTime(date, time){
    const m = moment.utc(sprintf("%s %s", date, time), 'YYYY/MM/DD HH:mm');
    return m.toDate().toISOString();
  }

  static renderFacebookIcon() {
    return(<span key="fb" className="auth-icon mr5">{I18n.t("dashboard.label_000098")}</span>);
  }

  static renderEmailIcon() {
    return(<span key="email" className="auth-icon mr5">{I18n.t("dashboard.label_000095")}</span>);
  }

  static renderTelIcon() {
    return(<span key="tel" className="auth-icon mr5">{I18n.t("dashboard.label_000096")}</span>);
  }

  static renderPassport() {
    return(<span key="passport" className="auth-icon mr5">{I18n.t("dashboard.label_000600")}</span>);
  }

  static defaultIcon() {
    return("https://spmkt-test.s3.amazonaws.com/images/api/default_user.png");
  }

  static userImageUrl(user, url) {
    if (SMAppHelper.userIsDeleted(user)) {
      return this.defaultIcon();
    } else {
      return url;
    }
  }

  static ownerImageUrl(owner, url) {
    if (SMAppHelper.ownerIsDeleted(owner)) {
      return this.defaultIcon();
    } else {
      return url;
    }
  }

  static renderRoomPriceText(room, displayArea = 'default', queries = null){
    const price = room.price_text_list[0];
    const isDirect = room.has_direct_reservation_plans ? true : false;
    const isTopHost = (room.owner.rank && room.owner.rank == SMConst.OwnerRank.SuperHost) ? true : false;
    const isLastMinuteDiscount = room.has_last_minute_discount_plans ? true : false;
    let directReservationIcon = null;
    let topHostIcon = null;
    let priceIcons = null;
    let lastMinuteDiscountIcon = null;
    let priceIconsClass = displayArea == 'top' ? "md-top-units__price-icon" : "units-item__price-icon";

    if (!price) {
     return false;
    }

    if (displayArea == 'top') {
      directReservationIcon = isDirect ? <i className="fa fa-bolt md-top-units__item-instant"></i> : null;
      topHostIcon = isTopHost ? <span className="icon-spm-top_host md-top-units__item-top-host"></span> : null;
      lastMinuteDiscountIcon = isLastMinuteDiscount ? <i className="icon-spm-discount md-top-units__item-icon-discount"></i> : null;
    } else {
      directReservationIcon = isDirect ? <i className="fa fa-bolt units-item__price-icon-instant"></i> : null;
      topHostIcon = isTopHost ? <span className="icon-spm-top_host units-item__price-icon-top-host"></span> : null;
      lastMinuteDiscountIcon = isLastMinuteDiscount ? <i className="icon-spm-discount units-item__price-icon-discount"></i> : null;
    }

    if (directReservationIcon || topHostIcon || lastMinuteDiscountIcon) {
      priceIcons = (
        <span className={priceIconsClass}>
         {directReservationIcon}
         {topHostIcon}
         {lastMinuteDiscountIcon}
        </span>
      );
    }

    if (room.inquiry_only) {
      if (displayArea == 'slider') {
        return room.inquiry_text;
      } else if (displayArea == 'top') {
        return (
          <p className="md-top-units__item-price">
            {room.inquiry_text}
            {priceIcons}
          </p>
        );
      } else {
        return (
          <p className="units-item__item-price">
            {room.inquiry_text}
            {priceIcons}
          </p>
        );
      }
    }

    if (price.max_price_text != null) {
      if (displayArea == 'slider') {
        if (price.min_price_unit_text == null) {
          return `${price.min_price_text}〜${price.max_price_text}${SMFormatHelper.priceUnit(price.max_price_unit_text, false)}`;
        } else {
          return `${price.min_price_text}${SMFormatHelper.priceUnit(price.min_price_unit_text, true)}${price.max_price_text}${SMFormatHelper.priceUnit(price.max_price_unit_text, false)}`;
        }
      } else if (displayArea == 'top') {
        if (price.min_price_unit_text == null) {
          return (
            <p className="md-top-units__item-price">
              {price.min_price_text}<span className="md-top-units__item-per">〜</span>
              {price.max_price_text}<span className="md-top-units__item-per">{SMFormatHelper.priceUnit(price.max_price_unit_text, false)}</span>
              {priceIcons}
            </p>
          );
        } else {
          return (
            <p className="md-top-units__item-price">
              {price.min_price_text}<span className="md-top-units__item-per">{SMFormatHelper.priceUnit(price.min_price_unit_text, true)}</span>
              {price.max_price_text}<span className="md-top-units__item-per">{SMFormatHelper.priceUnit(price.max_price_unit_text, false)}</span>
              {priceIcons}
            </p>
          );
        }
      } else {
        if (price.min_price_unit_text == null) {
          return (
            <p className="units-item__item-price">
              {price.min_price_text}<span className="units-item__item-per">〜</span>
              {price.max_price_text}<span className="units-item__item-per">{SMFormatHelper.priceUnit(price.max_price_unit_text, false)}</span>
              {priceIcons}
            </p>
          );
        } else {
          return (
            <p className="units-item__item-price">
              {price.min_price_text}<span className="units-item__item-per">{SMFormatHelper.priceUnit(price.min_price_unit_text, true)}</span>
              {price.max_price_text}<span className="units-item__item-per">{SMFormatHelper.priceUnit(price.max_price_unit_text, false)}</span>
              {priceIcons}
            </p>
          );
        }
      }
    } else {
      if (displayArea == 'slider') {
        return `${price.min_price_text}${SMFormatHelper.priceUnit(price.min_price_unit_text, false)}`;
      } else if (displayArea == 'top') {
        return <p className="md-top-units__item-price">{price.min_price_text}<span className="md-top-units__item-per">{SMFormatHelper.priceUnit(price.min_price_unit_text, false)}</span>{priceIcons}</p>;
      } else {
        return <p className="units-item__item-price">{price.min_price_text}<span className="units-item__item-per">{SMFormatHelper.priceUnit(price.min_price_unit_text, false)}</span>{priceIcons}</p>;
      }
    }
  }

  static unreadNumberLabel(badgeNumber){
    let label = '';
    if (badgeNumber && badgeNumber > 0) {
      label = badgeNumber;
      if (badgeNumber > 99) label = "99+";
    }
    return label;
  }

  static formatDate(datetime, format) {
    return moment(datetime).format(format);
  }
}

export default SMFormatHelper;



// WEBPACK FOOTER //
// ./app/javascript/components/helpers/SMFormatHelper.js